module.exports = __webpack_public_path__ + "static/how-to-pay-1-d10a23de8a09f5984888309b710d9149.png";